/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ErroreClientProblemaListFilter { 
    q?: string;
    app?: string;
    origine?: string;
    attore?: string;
    actor_user_id?: string;
    da?: string;
    a?: string;
}

